'use strict'

// import _ from 'underscore'
import naturalSort from 'javascript-natural-sort'
import {SORT_TYPES} from './constants'

/**
 * Returns true if a value is a number
 * @param {*} value - any kind of vaiable
 * @returns {Boolean}
 */
export const isInt = (value) => {
  return String(parseInt(value, 10)) === String(value)
}

/**
 * @name sortDataBy
 * @description sorts an array of objects by field - supports reverse sorting
 * @param {Array} data - the array for sorting
 * @param {String} field - the field to sort the array by
 * @param {String} type - the type for the sorting, could be either ASC or DESC
 * @returns {Array} - the same array sorted
 */
export const sortDataBy = (data = [], field, type = SORT_TYPES.ASC) => {
  // creating a copy not to change the original array
  const isDESC = type === SORT_TYPES.DESC

  // return a new instance of the array using Array.sort
  const sorted = data.sort((a, b) => {
    return naturalSort(String(a[field]), String(b[field]))
  })
  return isDESC ? sorted.reverse() : sorted
}

/**
 * Receives a sort type and return the opposite.
 * For DESC it will return ASC and for ASC it will return DESC.
 * @param {String} sortType - sort type
 * @returns {String} - sort type
 */
export const getOppositeSortType = (sortType) => {
  return sortType === SORT_TYPES.DESC ? SORT_TYPES.ASC : SORT_TYPES.DESC
}

/**
 * @name getColumnSortProperty
 * @description gets the property for sorting out of external column object
 * The order is sortBy, valueProperty and finnaly header
 * @param {Object} column - external column object
 * @returns {String}
 */
export const getColumnSortProperty = (column) => {
  return column.sortBy || column.valueProperty || column.header
}



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/Table/utils.js